import React from 'react'

import BasicActivity from '@components/myScores/ActivityEvent/BasicActivity'
import DiscussionActivity from '@components/myScores/ActivityEvent/DiscussionActivity'
import FollowActivity from '@components/myScores/ActivityEvent/FollowActivity'
import ScoreActivity from '@components/myScores/ActivityEvent/ScoreActivity'
import ExternalLink from '@components/shared/ExternalLink'
import NFIcon from '@components/shared/NFIcon'
import { BasicEvent, DiscussionEvent, Event, FollowEvent, ScoreEvent } from '@custom-types/activity'
import { buildAvatarUrl } from '@models/util/user.util'
import PageRoutes from '@utils/page-routes'

interface Props {
  event: Event
}

const ActivityEvent: React.FC<Props> = ({ event }) => {
  const { actor, action } = event

  if (!actor?.identified) {
    return null
  }

  const icon = getEventIcon(action)
  return (
    <div className="relative mb-1 p-2 bg-white dark:bg-black-bg2 rounded flex flex-row items-center hover:bg-opacity-60 dark:hover:bg-opacity-60 min-w-0">
      <ExternalLink href={PageRoutes.userProfilePath(actor.external_id)}>
        <div className="h-[35px] w-[35px] mr-2 overflow-hidden rounded-full">
          <img src={buildAvatarUrl(actor)} alt={actor.username} />
        </div>
      </ExternalLink>
      {icon && <NFIcon icon={icon} className="text-gray-icons dark:text-gray-icons-dm text-lg" />}
      {/*<div className="ml-3 flex-1">*/}
      <EventContent event={event} />
      {/*</div>*/}
    </div>
  )
}

export default ActivityEvent

interface EventContentProps {
  event: Event
}
const EventContent: React.FC<EventContentProps> = ({ event }) => {
  switch (event.action) {
    case 'favedYourScore':
    case 'commentedYourScore':
    case 'sharedScoreWithYou':
    case 'sharedScoreWithUser':
    case 'favedScore':
    case 'commentedScore':
    case 'publishedScore':
    case 'unfavedScore':
    case 'unfavedYourScore':
    case 'copiedYourScore':
    case 'copiedScore':
    case 'viewedYourScore':
    case 'viewedScore':
      return <ScoreActivity event={event as ScoreEvent} />

    case 'postedToDiscussion':
      return <DiscussionActivity event={event as DiscussionEvent} />

    case 'followedUser':
    case 'unfollowedUser':
      return <FollowActivity event={event as FollowEvent} />

    default:
      return <BasicActivity event={event as BasicEvent} />
  }
}

function getEventIcon(action?: string): string | null {
  switch (action) {
    case 'favedYourScore':
    case 'favedScore':
    case 'unfavedYourScore':
    case 'unfavedScore':
    case 'viewedYourScore':
    case 'viewedScore':
      return 'favorite-solid'

    case 'copiedYourScore':
    case 'copiedScore':
    case 'commentedYourScore':
    case 'commentedScore':
    case 'postedToDiscussion':
      return 'comment'

    case 'followedYou':
    case 'followedUser':
    case 'unfollowedYou':
    case 'unfollowedUser':
      return 'more-horz'

    case 'sharedScoreWithYou':
    case 'sharedScoreWithUser':
    case 'publishedScore':
      return 'share'

    default:
      return null
  }
}
